import { createReducer, on } from '@ngrx/store';

import { AuthActions } from '../actions/auth.actions';

import { CarRefActions } from '../actions/carref.actions';
import { CarRefStoreUtils } from '../store-utils/carref-store.utils';
import { CarEngine } from 'src/app/public/car/models/car-engine.model';
import { CarFeature } from 'src/app/public/car/models/car-feature.model';
import { CarJobTask } from 'src/app/public/car/models/car-job-task.model';
import { CarJobTemplate } from 'src/app/public/car/models/car-job-template.model';
import { CarMake } from 'src/app/public/car/models/car-make.model';
import { CarManufacturer } from 'src/app/public/car/models/car-manufacturer.model';
import { CarModel } from 'src/app/public/car/models/car-model.model';
import { CarVersion } from 'src/app/public/car/models/car-version.model';


export interface CarRefState {

    manufacturers: CarManufacturer[]; 
    makes: CarMake[]; 
    models: CarModel[]; 
    versions: CarVersion[]; 
    engines: CarEngine[]; 
    features: CarFeature[]; 

    jobTemplates: CarJobTemplate[];
    jobTasks: CarJobTask[];
    
    fetchingPreview: boolean;
    fetchingResults: boolean;
}

export const initialCarRefData: CarRefState = {
    
    manufacturers: [],
    makes: [], 
    models: [], 
    versions: [],
    engines: [],
    features: [],

    jobTemplates: [],
    jobTasks: [],

    fetchingPreview: false,
    fetchingResults: false
};

export const carRefReducer = createReducer(

    initialCarRefData,


    //manufacturers
    on( CarRefActions.manufacturerNewSuccess, (state, action) => {
        return {
            ...state,
            manufacturers: CarRefStoreUtils.addManufacturer (state.manufacturers, action.manufacturer),
            };
        }
    ),

    on( CarRefActions.manufacturerUpdateSuccess, (state, action) => {
        return {
            ...state,
            manufacturers: CarRefStoreUtils.updateManufacturer (state.manufacturers, action.manufacturer), 
            };
        }
    ),

    on( CarRefActions.manufacturerDeleteSuccess, (state, action) => {
        return {
            ...state,
            manufacturers: CarRefStoreUtils.deleteManufacturer(state.manufacturers, action.manufacturerId)
            };
        }
    ),

    on( CarRefActions.manufacturersFetchSuccess, (state, action) => {
        return {
            ...state,
            manufacturers: action.manufacturers
            };
        }
    ),

    //makes
    on( CarRefActions.makeNewSuccess, (state, action) => {
        return {
            ...state,
            makes: CarRefStoreUtils.addMake (state.makes, action.make),
            };
        }
    ),

    on( CarRefActions.makeUpdateSuccess, (state, action) => {
        return {
            ...state,
            makes: CarRefStoreUtils.updateMake (state.makes, action.make), 
            };
        }
    ),

    on( CarRefActions.makeDeleteSuccess, (state, action) => {
        return {
            ...state,
            makes: CarRefStoreUtils.deleteMake(state.makes, action.makeId)
            };
        }
    ),

    on( CarRefActions.makesFetchSuccess, (state, action) => {
        return {
            ...state,
            makes: action.makes
            };
        }
    ),


    //models
    on( CarRefActions.modelNewSuccess, (state, action) => {
        return {
            ...state,
            models: CarRefStoreUtils.addModel (state.models, action.model),
            };
        }
    ),

    on( CarRefActions.modelUpdateSuccess, (state, action) => {
        return {
            ...state,
            models: CarRefStoreUtils.updateModel (state.models, action.model), 
            };
        }
    ),

    on( CarRefActions.modelDeleteSuccess, (state, action) => {
        return {
            ...state,
            models: CarRefStoreUtils.deleteModel(state.models, action.modelId)
            };
        }
    ),

    on( CarRefActions.modelsFetchSuccess, (state, action) => {
        return {
            ...state,
            models: action.models
            };
        }
    ),


    //versions
    on( CarRefActions.versionNewSuccess, (state, action) => {
        return {
            ...state,
            versions: CarRefStoreUtils.addVersion (state.versions, action.version),
            };
        }
    ),

    on( CarRefActions.versionUpdateSuccess, (state, action) => {
        return {
            ...state,
            versions: CarRefStoreUtils.updateVersion (state.versions, action.version), 
            };
        }
    ),

    on( CarRefActions.versionDeleteSuccess, (state, action) => {
        return {
            ...state,
            versions: CarRefStoreUtils.deleteVersion(state.versions, action.versionId)
            };
        }
    ),

    on( CarRefActions.versionsFetchSuccess, (state, action) => {
        return {
            ...state,
            versions: action.versions
            };
        }
    ),


    //engines
    on( CarRefActions.engineNewSuccess, (state, action) => {
        return {
            ...state,
            engines: CarRefStoreUtils.addEngine (state.engines, action.engine),
            };
        }
    ),

    on( CarRefActions.engineUpdateSuccess, (state, action) => {
        return {
            ...state,
            engines: CarRefStoreUtils.updateEngine (state.engines, action.engine), 
            };
        }
    ),

    on( CarRefActions.engineDeleteSuccess, (state, action) => {
        return {
            ...state,
            engines: CarRefStoreUtils.deleteEngine(state.engines, action.engineId)
            };
        }
    ),

    on( CarRefActions.enginesFetchSuccess, (state, action) => {
        return {
            ...state,
            engines: action.engines
            };
        }
    ),


    //features
    on( CarRefActions.featureNewSuccess, (state, action) => {
        return {
            ...state,
            features: CarRefStoreUtils.addFeature (state.features, action.feature),
            };
        }
    ),

    on( CarRefActions.featureUpdateSuccess, (state, action) => {
        return {
            ...state,
            features: CarRefStoreUtils.updateFeature (state.features, action.feature), 
            };
        }
    ),

    on( CarRefActions.featureDeleteSuccess, (state, action) => {
        return {
            ...state,
            features: CarRefStoreUtils.deleteFeature(state.features, action.featureId)
            };
        }
    ),

    on( CarRefActions.featuresFetchSuccess, (state, action) => {
        return {
            ...state,
            features: action.features
            };
        }
    ),


    //jobTemplates
    on( CarRefActions.jobTemplateNewSuccess, (state, action) => {
        return {
            ...state,
            jobTemplates: CarRefStoreUtils.addJobTemplate (state.jobTemplates, action.jobTemplate),
            };
        }
    ),

    on( CarRefActions.jobTemplateUpdateSuccess, (state, action) => {
        return {
            ...state,
            jobTemplates: CarRefStoreUtils.updateJobTemplate (state.jobTemplates, action.jobTemplate), 
            };
        }
    ),

    on( CarRefActions.jobTemplateDeleteSuccess, (state, action) => {
        return {
            ...state,
            jobTemplates: CarRefStoreUtils.deleteJobTemplate(state.jobTemplates, action.jobTemplateId)
            };
        }
    ),

    on( CarRefActions.jobTemplatesFetchSuccess, (state, action) => {
        return {
            ...state,
            jobTemplates: action.jobTemplates
            };
        }
    ),


    //jobTasks
    on( CarRefActions.jobTaskNewSuccess, (state, action) => {
        return {
            ...state,
            jobTasks: CarRefStoreUtils.addJobTask (state.jobTasks, action.jobTask),
            };
        }
    ),

    on( CarRefActions.jobTaskUpdateSuccess, (state, action) => {
        return {
            ...state,
            jobTasks: CarRefStoreUtils.updateJobTask (state.jobTasks, action.jobTask), 
            };
        }
    ),

    on( CarRefActions.jobTaskDeleteSuccess, (state, action) => {
        return {
            ...state,
            jobTasks: CarRefStoreUtils.deleteJobTask(state.jobTasks, action.jobTaskId)
            };
        }
    ),

    on( CarRefActions.jobTasksFetchSuccess, (state, action) => {
        return {
            ...state,
            jobTasks: action.jobTasks
            };
        }
    ),



    // logout

    on( AuthActions.logoutSubmit, (state) => {
        
        return {
            ...state,
            manufacturers: [],
            makes: [], 
            models: [], 
            versions: [],
            engines: [],
            features: [],

            jobs: [],
            jobTasks: []
        };
    }),

);

// selectors

export const selectCarRefFetchingPreview = (state: CarRefState) => state.fetchingPreview;
export const selectCarRefFetchingResults = (state: CarRefState) => state.fetchingResults;



    